import { asButton } from '@getstream/ui-library/build';

export const FormButton = asButton((props: any) => <button {...props} />);
